import apiSlice from './apiSlice';

export interface CreateEventRequest {
  title: string;
  name: string;
  date: string;
  // level: string;
  place: string;
  // issuingAuthority: string;
  description: string;
}
export interface CreateEventResponse {
  message: string;
  event: Event;
}
export interface CertificateItem {
  _id: string;
  title: string;
  issuingAuthority: string;
  issuedAt: string;
  level: string;
  description: string;
  eventId: string;
  creator: string;
  createdAt: string;
  updatedAt: string;
  __v: number;

  eventName: string;
  eventLocation: string;
}

export interface Event {
  _id: string;
  title: string;
  name: string;
  description: string;
  date: string;
  place: string;
  file?: string;
  baseCertificatePath?: string;
  totalCertificates: number;
  certificates: CertificateItem[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}
export interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}
export interface GetEventsResponse {
  data: Event[];
  pagination: Pagination;
}
export interface GetEventsRequest {
  search?: string;
  page?: number;
  limit?: number;
}
export const eventApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createEvent: builder.mutation<CreateEventResponse, FormData>({
      query: (body) => ({
        url: '/events/create',
        method: 'POST',
        body,
      }),
    }),
    getEvents: builder.query<GetEventsResponse, { search?: string; page?: number; limit?: number }>(
      {
        query: ({ search = '', page = 1, limit = 7 }) => ({
          url: '/events',
          params: { search, page, limit },
        }),
      }
    ),
  }),
});

export const { useCreateEventMutation, useGetEventsQuery } = eventApi;
